import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import classNames from 'classnames';
import { useField } from 'formik';
import Label from '../lib/Label';
import Error from '../lib/Error';
import Container from '../lib/Container';

export default function HtmlInput(props) {

    const {
        label,
        name,
        placeholder,
        disabled,
        onChange,
        readOnly,
        fieldId,
        columns,
        required
    } = props;


    const [field, meta, {setValue}] = useField({
        name,
        readOnly,
        id: fieldId || name
    });

    function onChangeHandler(value) {

        if (onChange && typeof onChange === 'function') {
            onChange(value, name)
        }

        return setValue(value);
    }

    const InputClasses = classNames({
        "block": true,
        "w-full": true,
        "rounded-xl": true,
        "border-line": true,
        "shadow-sm": true,
        "focus:z-10": true,
        "focus:border-primary": true,
        "disabled:bg-light": true,
        "disabled:cursor-not-allowed": true,
        "disabled:opacity-30": true,
        "border-red": meta?.error
    })

    return (
        <Container columns={columns || 1}>
            {label &&
                <Label
                    label={label}
                    name={name}
                    fieldId={fieldId}
                    required={required}
                />
            }

            <Editor
                {...field}
                tinymceScriptSrc='/tinymce/tinymce.min.js'
                licenseKey='gpl'
                plugins="code fullscreen"
                menubar="format tools table"
                toolbar="undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link image | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen | pagebreak anchor codesample"
                disabled={disabled}
                className={InputClasses}
                placeholder={placeholder}
                onEditorChange={onChangeHandler}
            />

            {meta?.error && (
                <Error error={meta.error}/>
            )}
        </Container>
    )
}
